import { render, staticRenderFns } from "./ItemOrder.vue?vue&type=template&id=a5cb990c&lang=pug&"
import script from "./ItemOrder.vue?vue&type=script&lang=ts&"
export * from "./ItemOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ItemOrder.vue?vue&type=style&index=0&id=a5cb990c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports